import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { onBeforeUnmount, onMounted, ref } from 'vue';

import RetryForm from './RetryForm.vue';
import RoundPoints from './RoundPoints.vue';

import { RoundStatus, useGameStore } from '@/stores/gameStore';
import { handleGameOver, isGameOver } from '@/utils/roundEndHelper';


export default /*#__PURE__*/_defineComponent({
  __name: 'RoundResults',
  setup(__props) {

const showForm = ref(false);
const gameStore = useGameStore();

let timer: number;

function startTimer() {
  timer = setInterval(() => {
    if (isGameOver()) {
      handleGameOver();
    } else {
      showForm.value = true;
    }
  }, 4000);
}

function stopTimer() {
  clearInterval(timer);
}

onMounted(() => {
  if (
    gameStore.userInput === '' &&
    gameStore.roundStatus === RoundStatus.EXPIRED
  ) {
    showForm.value = true;
  } else {
    startTimer();
  }
});
onBeforeUnmount(stopTimer);

return (_ctx: any,_cache: any) => {
  return (showForm.value)
    ? (_openBlock(), _createBlock(RetryForm, { key: 0 }))
    : (_openBlock(), _createBlock(RoundPoints, { key: 1 }))
}
}

})